<template>
    <LsInfoRow
        class="ls-info-row-pricing"
        :left-image="require('./assets/pricing.svg')"
        label="Price Per Service"
        :value="value"
    >
        <v-popover>
            <img :src="require('../../assets/info.svg')" />
            <template slot="popover">
                <div class="ls-info-row-pricing--popover">
                    <div v-if="isInstantQuote">
                        <span class="ls-info-row-pricing--heading">{{
                            `Original${payoutAccepted === 'primary' ? ' (Accepted)' : ''}`
                        }}</span>
                    </div>
                    <div>
                        <span>Contractor Payout:</span>
                        <span>{{ pricingInfo.payout | currency }}</span>
                    </div>
                    <div v-if="pricingInfo.commission">
                        <span>LawnStarter Commission:</span>
                        <span>{{ pricingInfo.commission }}</span>
                    </div>
                    <div>
                        <span>LawnStarter Revenue:</span>
                        <span>{{ (schedule.price - pricingInfo.payout) | currency }}</span>
                    </div>
                    <div v-if="schedule.fee_trust">
                        <span>Trust & Safety Fee:</span>
                        <span>{{ schedule.fee_trust | currency }}</span>
                    </div>
                    <div v-if="hasTaxAmount">
                        <span>Tax:</span>
                        <span>{{ schedule.tax_amount | currency }}</span>
                    </div>
                    <div class="ls-info-row-pricing--popover-hr" />
                    <div class="ls-info-row-pricing--popover-price">
                        <span>{{
                            isInstantQuote || isRequiredService ? 'Total' : "Customer's Price:"
                        }}</span>
                        <span>{{ totalAmount | currency }}</span>
                    </div>
                </div>

                <div v-if="isInstantQuote" class="ls-info-row-pricing--popover">
                    <div>
                        <span class="ls-info-row-pricing--heading backup">{{
                            `Backup${payoutAccepted === 'backup' ? ' (Accepted)' : ''}`
                        }}</span>
                    </div>
                    <div>
                        <span>Contractor Payout:</span>
                        <span>{{ pricingInfo.payout_backup | currency }}</span>
                    </div>
                    <div v-if="pricingInfo.commission_backup">
                        <span>LawnStarter Commission:</span>
                        <span>{{ pricingInfo.commission_backup }}</span>
                    </div>
                    <div>
                        <span>LawnStarter Revenue:</span>
                        <span>{{ (schedule.price - pricingInfo.payout_backup) | currency }}</span>
                    </div>
                    <div>
                        <span>Tax:</span>
                        <span>{{ schedule.tax_amount | currency }}</span>
                    </div>
                    <div class="ls-info-row-pricing--popover-hr" />

                    <div class="ls-info-row-pricing--popover-price">
                        <span>Total</span>
                        <span>{{ totalAmount | currency }}</span>
                    </div>
                </div>
            </template>
        </v-popover>
    </LsInfoRow>
</template>

<script>
import VueTypes from 'vue-types';
import { lsFilters, lsPropTypeHelpers } from 'ls-vue-common';
import _ from 'lodash';
import LsInfoRow from '../LsInfoRow/LsInfoRow.vue';

export default {
    name: 'LsInfoRowPricing',
    components: {
        LsInfoRow,
    },
    props: {
        schedule: VueTypes.shape({
            payout: VueTypes.number,
            commission: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
            price: VueTypes.number,
            fee_trust: VueTypes.custom(lsPropTypeHelpers.numberOrNull),
            tax_amount: VueTypes.number,
            total_amount: VueTypes.number,
            instant_quote: VueTypes.oneOfType([
                VueTypes.shape({
                    payout_primary: VueTypes.number.isRequired,
                    payout_backup: VueTypes.number.isRequired,
                    commission_primary: VueTypes.number.isRequired,
                    commission_backup: VueTypes.number.isRequired,
                    payout_accepted: VueTypes.custom(lsPropTypeHelpers.stringOrNull),
                }).loose,
                VueTypes.oneOfType([null]),
            ]),
        }).isRequired.loose,
    },
    computed: {
        value() {
            return `${lsFilters.currency({ amount: this.totalAmount })}`;
        },
        isInstantQuote() {
            return this.schedule.instant_quote;
        },
        isRequiredService() {
            return this.schedule.__typename === 'RequiredService';
        },
        pricingInfo() {
            if (this.isInstantQuote) {
                const {
                    payout_primary,
                    payout_backup,
                    commission_primary,
                    commission_backup,
                } = this.schedule.instant_quote;

                return {
                    payout: payout_primary,
                    payout_backup,
                    commission: this.commission(commission_primary),
                    commission_backup: this.commission(commission_backup),
                };
            }
            return {
                payout: this.schedule.payout,
                commission: this.commission(this.schedule.commission),
            };
        },
        payoutAccepted() {
            return this.schedule.instant_quote.payout_accepted;
        },
        hasTaxAmount() {
            return _.has(this.schedule, 'tax_amount');
        },
        totalAmount() {
            return this.schedule.total_amount || this.schedule.price;
        },
    },
    methods: {
        commission(commission) {
            return this.isInstantQuote
                ? `${(commission * 100).toFixed(2)}%`
                : `${_.toNumber(commission).toFixed(2)}%`;
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-info-row-pricing--popover {
    width: 240px;
    div {
        display: flex;
        justify-content: space-between;
        font-weight: $medium;
        span {
            color: $secondary-dark;
        }
    }
    div:not(:last-child) {
        margin-bottom: 5px;
    }
}

.ls-info-row-pricing--heading {
    font-weight: $bold;
    margin-bottom: 10px;

    &.backup {
        margin-top: 30px;
    }
}

.ls-info-row-pricing--popover-hr {
    height: 1px;
    width: 240px;
    background-color: $secondary-light;
    margin: 10px 0 15px 0 !important;
}

.ls-info-row-pricing--popover-price {
    > span:not(:last-child) {
        font-weight: $bold !important;
    }
}
</style>
